// extracted by mini-css-extract-plugin
export default {"editorError":"styles_editorError__dEBvL"};